import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponseBase } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ServiceBase } from './service-base';
import { SelectListItem, Language } from '../models';

@Injectable({
  providedIn: 'root'
})
export class LanguageService extends ServiceBase<Language> {
  constructor(protected override http: HttpClient,
              @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl, 'api/language');

  }

  public getLanguages(onlyActive: boolean = true, lanId: boolean = false): Observable<SelectListItem[]> {
    return this.http
      .get<SelectListItem[]>(
        `${this.baseUrl}/select-list`,
        {
          params: { onlyActive, lanId },
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          },),
        }
      );
  }

  public storeLanguageInLocalStorage(lang): void {
    localStorage.setItem('lang', lang);
  }

  public getLanguageFromLocalStorage(): string {
    return localStorage.getItem('lang');
  }

  public removeLanguageFromLocalStorage(): void {
    localStorage.removeItem('lang');
  }
}
